import { render } from "./SelfAssessmentV2FreeForm.vue?vue&type=template&id=a5ba4780&scoped=true"
import script from "./SelfAssessmentV2FreeForm.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2FreeForm.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2FreeForm.vue?vue&type=style&index=0&id=a5ba4780&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ba4780"]])

export default __exports__